import gql from 'graphql-tag';
import ContentFields from '../fragments/content';

export default gql`
  mutation removeBookmark(
    $id: Int!
  ) {
    removeBookmark(
      id: $id
    ) {
      id
      content {
        ...ContentFields
      }
    }
  }
  ${ContentFields}
`;
